var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-comp":"memberInvite"}},[_c('el-container',{staticStyle:{"flex-wrap":"wrap"},attrs:{"element-loading-background":"rgba(255, 255, 255, 1)"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }